export default __webpack_public_path__ + "static/media/knews1.13b48fd4.png";